import { Component, ElementRef, HostListener, OnInit, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { LayoutService } from '../../user-area-layout.service';
import { NavigationService } from '../../../../../services/navigation.service';
import { Environment, EnvironmentDescriptor } from '../../../../../../environment/types';
import { UserIdentityService } from '../../../../../../security/authentication/user-identity.service';
import { AuthenticationService } from '../../../../../../security/authentication/authentication.service';

@Component({
  selector: 'mcb-portal-user-area-status', templateUrl: './user-status.component.html'
})
export class PortalUserAreaUserStatusComponent implements OnInit {
  showUserStatusPanel = false;
  userFullName: string;

  constructor(
    private router: Router,
    @Inject(Environment) private env: EnvironmentDescriptor,
    private userIdentity: UserIdentityService,
    private userAuthService: AuthenticationService,
    private layoutService: LayoutService,
    private navService: NavigationService,
    private eRef: ElementRef) {
  }

  ngOnInit() {
    this.userFullName = this.userIdentity.user.fullName;
    this.layoutService.onUserStatusToggle.subscribe(userStatusPanel => {
      this.showUserStatusPanel = userStatusPanel;
    });

  }

  @HostListener('click', ['$event']) clickInside(event) {
    this.layoutService.toggleUserStatus();
  }

  @HostListener('document:click', ['$event']) clickout(event) {
    const el = event.target as HTMLElement;
    if (!this.existingForDocumentClick(el.className)) {
      if (this.layoutService.getUserStatusStatus()) {
        this.layoutService.hideUserStatus();
      }
    }
  }

  onSignoutClick() {
    this.userAuthService.signout().subscribe(x => {
      if (this.env.useZcoreSignin) {
        this.navService.goToZCoreSigninPage();
      } else {
        this.navService.goToSigninPage();
      }
    });
  }

  private existingForDocumentClick(classname) {
    let result = false;
    const listOfClass: string[] = ['mcb-user-status', 'mcb-user-avatar', 'mcb-user-title', 'mcb-user-panel', 'mcb-user-panel-header', 'mcb-user-panel-menu'];
    listOfClass.forEach(l => {
      if (l == classname) {
        result = true;
      }
    });
    return result;
  }

  goToChangePass() {
    this.router.navigate(['/master/platform/user-mng/change-password']);
  }


}
